import React from 'react'
import { connect } from 'react-redux'
import { differenceInCalendarDays } from 'date-fns'
import OverSixDays from './OverSixDays'
import UnderSixDays from './UnderSixDays'
import { loadDeliveringRestaurants } from '../../redux/modules/comingSoon'
import ModalPopup from '../common/ModalPopup'
import CollectEmailPanel from '../home/CollectEmailPanel'

const Join = ({ locationId, toggleJoin }) => (
  <ModalPopup onCancel={toggleJoin}>
    <div className="row">
      <div className="col-xs-12">
        <h2 className="title">Register for Foodsby</h2>
        <CollectEmailPanel locationId={locationId} />
      </div>
    </div>
  </ModalPopup>
)

class ComingSoon extends React.Component {
  state = {
    showJoin: false
  }
  toggleJoin = () => {
    this.setState({ showJoin: !this.state.showJoin })
  }
  componentDidMount() {
    this.props.loadDeliveringRestaurants(this.props.locationId)
  }

  render() {
    const {
      activationDate,
      isAuthenticated,
      loadDeliveriesForLocation,
      loadingDeliveringRestaurants,
      locationId,
      onChangeDay
    } = this.props
    const { showJoin } = this.state
    const DAYS_UNTIL_LAUNCH = differenceInCalendarDays(
      activationDate,
      new Date()
    )
    return (
      <div>
        {showJoin && (
          <Join locationId={locationId} toggleJoin={this.toggleJoin} />
        )}
        {DAYS_UNTIL_LAUNCH < 6 ? (
          <UnderSixDays
            activationDate={activationDate}
            onChangeDay={onChangeDay}
            isAuthenticated={isAuthenticated}
            loadingDeliveringRestaurants={loadingDeliveringRestaurants}
            restaurantLogos={loadDeliveriesForLocation}
            showJoin={this.toggleJoin}
          />
        ) : DAYS_UNTIL_LAUNCH >= 6 ? (
          <OverSixDays
            activationDate={activationDate}
            isAuthenticated={isAuthenticated}
            loadingDeliveringRestaurants={loadingDeliveringRestaurants}
            restaurantLogos={loadDeliveriesForLocation}
            daysUntilLaunch={DAYS_UNTIL_LAUNCH}
            showJoin={this.toggleJoin}
          />
        ) : (
          <div className="row center-xs">
            <i className="spinner spinner-lg primary" />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {
    loadDeliveriesForLocation,
    loadingDeliveringRestaurants
  } = state.comingSoon
  const { location } = state.location
  return {
    loadDeliveriesForLocation,
    loadingDeliveringRestaurants,
    location
  }
}

const mapDispatchToProps = {
  loadDeliveringRestaurants
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ComingSoon)
